import { createContext, useContext } from "react";

import type { Task } from "@/core/types";

type LogInTaskContextValue = {
  onTaskCompleted: () => void;
  onTaskSkipped: () => void;
  task: null | Task;
};

const LogInTaskContext = createContext<LogInTaskContextValue | null>(null);

export function useLogInTaskContext() {
  const context = useContext(LogInTaskContext);

  if (!context) {
    throw new Error("useLogInTaskContext must be used within LogInTaskProvider");
  }

  return context;
}

export const LogInTaskProvider = LogInTaskContext.Provider;
